// src/components/FoodItemCardSkeleton.js
import React from 'react';
import { Box, Skeleton } from '@mui/material';
import './style.css';

const FoodItemCardSkeleton = () => (
  <Box className="food-items-main-container">
    <Box className="food-items-container">
      {/* Left image placeholder */}
      <Skeleton  variant="rectangular" width={300} height={150} animation="wave" />
      {/* Right content */}
      <Box className="d-flex food-items-content">
        <Box sx={{ width: '100%' }}>
          {/* Title */}
          <Skeleton variant="text" width="60%" height={28} animation="wave" sx={{ mb: 1 }} />
          {/* Subtitle / icon row */}
          <Box className="d-flex align-items-center" sx={{ mb: 2 }}>
            <Skeleton variant="circular" width={18} height={18} animation="wave" />
            <Skeleton variant="text" width="40%" height={20} animation="wave" sx={{ ml: 1 }} />
          </Box>

          {/* Price & actions */}
          <Box className="price-action-section d-flex align-items-center justify-content-between">
            <Skeleton variant="text" width={60} height={28} animation="wave" />
            <Box className="d-flex align-items-center" sx={{ gap: '5px' }}>
              <Skeleton  variant="circular"  width={32}  height={32}  animation="wave" />
              <Skeleton variant="circular" width={32} height={32} animation="wave" />
              <Skeleton  variant="rectangular"  width={48}  height={28}  animation="wave"  sx={{ borderRadius: '16px' }} />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  </Box>
);

export default FoodItemCardSkeleton;
